import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './Tag.module.css';

const Tag = ({
  name,
  count,
  color = '#f1404b',
  size = 'medium',
  variant = 'default',
  onClick,
  className = ''
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick(name);
    } else {
      navigate(`/search?q=${encodeURIComponent(name)}`);
    }
  };

  return (
    <span
      className={`tag tag-${size} tag-${variant} ${className}`}
      onClick={handleClick}
      style={{
        '--tag-color': color,
        borderColor: variant === 'outlined' ? color : 'transparent',
        backgroundColor: variant === 'filled' ? color : 'transparent',
        color: variant === 'filled' ? 'white' : color
      }}
    >
      <span className="tag-name">{name}</span>
      {count !== undefined && (
        <span className="tag-count">({count})</span>
      )}
    </span>
  );
};

export default Tag;